<template>
  <figure class="image" :style="`height: ${size}px; width: ${size}px;`" :class="customClass">
    <div class="is-circular" :style="`background: ${getColor(letters)};`">
      <span :style="`font-size: ${parseInt(size) / 2.6}px;`">
        {{ letters }}
      </span>
    </div>
  </figure>
</template>

<script>
import { getColorByLetter } from '/@/modules/core/app/helpers/ColorHelper';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'GenericAvatar',
  props: {
    letters: { type: String, required: true },
    size: { type: String, default: '32' },
    customClass: { type: String }
  },
  methods: {
    getColor(letters) {
      return getColorByLetter(letters.charAt(0));
    }
  }
};
</script>
